import {
    CreateAttachmentHandler,
    ComposeUniqueState,
    FileSelectionFilter,
    lazyAttachmentFilePicker,
} from 'owa-attachment-filepicker';
import { fetchUploadFolder, getUploadFolder } from 'owa-attachments-upload-folder';
import {
    lazyGetAvailableLocalAttachmentSize,
    AttachmentWellViewState,
} from 'owa-attachment-well-data';
import type EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { isFeatureEnabled } from 'owa-feature-flags';
import { lazyInsertLinks } from 'owa-insert-link';
import { getAttendeeLists } from '../utils/getAttendees';

export default async function openFilePickerAndAttach(
    editorViewState: EditorViewState,
    isInline: boolean,
    isOnGroupCalendar: boolean,
    handler: CreateAttachmentHandler,
    attachmentWell: AttachmentWellViewState,
    targetWindow: Window,
    fromAddress: string,
    formId: string
) {
    // TODO: Save the event draft

    const maximumClassicAttachmentSize = (await lazyGetAvailableLocalAttachmentSize.import())(
        attachmentWell
    );
    let uploadFolder = getUploadFolder();
    if (!uploadFolder) {
        uploadFolder = await fetchUploadFolder();
    }

    const onGetAttendeeLists = () => {
        return getAttendeeLists(formId);
    };

    let insertLinkHandler = null;
    if (
        isFeatureEnabled('doc-deprecateCloudy-preview') ||
        isFeatureEnabled('doc-deprecateCloudy-preview-thumbnailView')
    ) {
        insertLinkHandler = async params => {
            const insertLinksHost = {
                getRecipientWells: onGetAttendeeLists,
                attachmentWell: attachmentWell,
            };
            const insertLinks = await lazyInsertLinks.import();
            insertLinks(params.files, insertLinksHost, editorViewState, fromAddress, targetWindow);
        };
    }

    lazyAttachmentFilePicker.importAndExecute(handler, insertLinkHandler, {
        fileSelectionFilter: isInline ? FileSelectionFilter.Images : FileSelectionFilter.None,
        maxAllowedLocalFilesSize: maximumClassicAttachmentSize,
        supportsInsertLink:
            isFeatureEnabled('doc-deprecateCloudy-preview-thumbnailView') ||
            isFeatureEnabled('doc-deprecateCloudy-preview'),
        uploadConfiguration: {
            folderName: uploadFolder.folderName ? uploadFolder.folderName : null,
            composeUniqueState: isOnGroupCalendar
                ? ComposeUniqueState.GroupCalendar
                : ComposeUniqueState.None,
        },
        targetWindow: targetWindow,
    });
}
